module.exports = __webpack_public_path__ + "static/bardem-animated-logo-0dfea7ff1222d0037654d628aad4a5ef.gif";